// extracted by mini-css-extract-plugin
export var deleteModal = "_ro-0";